const baseURL = "https://weoxh23k82.execute-api.ap-south-1.amazonaws.com/dev/api/asn/"
// const baseURL = "http://192.168.1.69:5004/dev/api/asn/"

export const createASNAPI = baseURL+"createAsn"
export const getAllASN = baseURL+"getAllASNDetails/"
export const trackASN = baseURL+"trackVehicleNo/"
